import {Injectable} from '@angular/core';
import {EventService} from './event.service';

@Injectable()
export class DispatchService {

  constructor(private _eventService: EventService) {
    this._eventService.menuState$.subscribe(menuState => {
      const menuCopy = JSON.parse(JSON.stringify(menuState));
      const event = new CustomEvent('lvmenu', {detail: menuCopy});
      window.dispatchEvent(event);
    });
  }
}
